import storySubmission from '../images/Submit_Story_Form.pdf';
import firstQuarter2021 from '../images/Newsletter_February_2021.pdf';
import secondQuarter2021 from '../images/Newsletter_May_2021.pdf';
import thirdQuarter2021 from '../images/Newsletter_August_2021.pdf';
import fourthQuarter2021 from '../images/Newsletter_November_2021.pdf';
import firstQuarter2022 from '../images/Newsletter_February_2022.pdf';
import secondQuarter2022 from '../images/Newsletter_May_2022.pdf';
import thirdQuarter2022 from '../images/Newsletter_August_2022.pdf';
import fourthQuarter2022 from '../images/Newsletter_November_2022.pdf';
import firstQuarter2023 from '../images/Newsletter_February_2023.pdf';
import secondQuarter2023 from '../images/Newsletter_May_2023.pdf';
import thirdQuarter2023 from '../images/Newsletter_August_2023.pdf';
import fourthQuarter2023 from '../images/Newsletter_November_2023.pdf';
import firstQuarter2024 from '../images/Newsletter_February_2024.pdf';
import secondQuarter2024 from '../images/Newsletter_May_2024.pdf';
import thirdQuarter2024 from '../images/Newsletter_August_2024.pdf';
import fourthQuarter2024 from '../images/Newsletter_November_2024.pdf';
import firstQuarter2025 from '../images/Newsletter_February_2025.pdf';
import secondQuarter2025 from '../images/Newsletter_May_2025.pdf';
import thirdQuarter2025 from '../images/Newsletter_August_2025.pdf';
import fourthQuarter2025 from '../images/Newsletter_November_2025.pdf';
import firstQuarter2026 from '../images/Newsletter_February_2026.pdf';

const Newsletters = [
    {
        id: 'storySubmission',
        path: storySubmission,
        name: 'Newsletter Story Submission Form'
    },
    {
        id: 'firstQuarter2021',
        path: firstQuarter2021,
        name: '1st Quarter 2021 Newsletter'
    },
    {
        id: 'secondQuarter2021',
        path: secondQuarter2021,
        name: '2nd Quarter 2021 Newsletter'
    },
    {
        id: 'thirdQuarter2021',
        path: thirdQuarter2021,
        name: '3rd Quarter 2021 Newsletter'
    },
    {
        id: 'fourthQuarter2021',
        path: fourthQuarter2021,
        name: '4th Quarter 2021 Newsletter'
    },
    {
        id: 'firstQuarter2022',
        path: firstQuarter2022,
        name: '1st Quarter 2022 Newsletter'
    },
    {
        id: 'secondQuarter2022',
        path: secondQuarter2022,
        name: '2nd Quarter 2022 Newsletter'
    },
    {
        id: 'thirdQuarter2022',
        path: thirdQuarter2022,
        name: '3rd Quarter 2022 Newsletter'
    },
    {
        id: 'fourthQuarter2022',
        path: fourthQuarter2022,
        name: '4th Quarter 2022 Newsletter'
    },
    {
        id: 'firstQuarter2023',
        path: firstQuarter2023,
        name: '1st Quarter 2023 Newsletter'
    },
    {
        id: 'secondQuarter2023',
        path: secondQuarter2023,
        name: '2nd Quarter 2023 Newsletter'
    },
    {
        id: 'thirdQuarter2023',
        path: thirdQuarter2023,
        name: '3rd Quarter 2023 Newsletter'
    },
    {
        id: 'fourthQuarter2023',
        path: fourthQuarter2023,
        name: '4th Quarter 2023 Newsletter'
    },
    {
        id: 'firstQuarter2024',
        path: firstQuarter2024,
        name: '1st Quarter 2024 Newsletter'
    },
    {
        id: 'secondQuarter2024',
        path: secondQuarter2024,
        name: '2nd Quarter 2024 Newsletter'
    },
    {
        id: 'thirdQuarter2024',
        path: thirdQuarter2024,
        name: '3rd Quarter 2024 Newsletter'
    },
    {
        id: 'fourthQuarter2024',
        path: fourthQuarter2024,
        name: '4th Quarter 2024 Newsletter'
    },
    {
        id: 'firstQuarter2025',
        path: firstQuarter2025,
        name: '1st Quarter 2025 Newsletter'
    },
    {
        id: 'secondQuarter2025',
        path: secondQuarter2025,
        name: '2nd Quarter 2025 Newsletter'
    },
    {
        id: 'thirdQuarter2025',
        path: thirdQuarter2025,
        name: '3rd Quarter 2025 Newsletter'
    },
    {
        id: 'fourthQuarter2025',
        path: fourthQuarter2025,
        name: '4th Quarter 2025 Newsletter'
    },
    {
        id: 'firstQuarter2026',
        path: firstQuarter2026,
        name: '1st Quarter 2026 Newsletter'
    },
];

export default Newsletters;